/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['admin-button[_ngcontent-%COMP%]{display:inline-block;margin-right:5px;margin-bottom:10px}admin-button[_ngcontent-%COMP%]:last-child{margin-right:0}.button-group-wrapper[_ngcontent-%COMP%]{text-align:center}.panel--justified[_ngcontent-%COMP%]{z-index:2}.panel--vertical[_ngcontent-%COMP%]{z-index:3}.panel--outlined-group[_ngcontent-%COMP%]{z-index:4}.panel--normal-group[_ngcontent-%COMP%]{z-index:5}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdWktZWxlbWVudC9idXR0b24vYnV0dG9uLWRlbW8uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC91aS1lbGVtZW50L2J1dHRvbi9idXR0b24tZGVtby5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/ui-element/button/button-demo.component.scss.shim.ngstyle.ts